<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 18px; ">
      <el-breadcrumb-item :to="{ name: 'ReportList' }">报表</el-breadcrumb-item>
      <el-breadcrumb-item>
        <span v-if="reportType=='day'">日报</span>
        <span v-if="reportType=='week'">周报</span>
        <span v-if="reportType=='month'">月报</span>
        <span v-if="reportType=='custom'">自定义时间</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-date-picker
      v-if="reportType == 'custom'"
      style="margin-top: 20px"
      v-model="time"
      type="datetimerange"
      :picker-options="pickerOptions"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      align="right"
      value-format="yyyy-MM-dd HH:mm:ss">
    </el-date-picker>
    <el-button type="primary" style="margin-left: 10px;margin-top: 15px"
               v-if="reportType == 'custom'"
               @click="getStatistics">查询所有</el-button>
    <el-button type="primary" style="margin-left: 10px;margin-top: 15px" @click="getUnusualTop">查询Top10</el-button>


    <el-table :data="tableData"
              :header-cell-style="{'textAlign':'center'}"
              :cell-style="{'textAlign':'center'}"
              style="width: 100%">
      <el-table-column prop="group" label="系统名称"></el-table-column>
      <el-table-column prop="name" label="监控名称"></el-table-column>
      <el-table-column prop="sTimes" label="成功次数"></el-table-column>
      <el-table-column prop="eTimes" label="失败次数"></el-table-column>
      <el-table-column prop="tTimes" label="总次数"></el-table-column>
      <el-table-column prop="rate" label="成功率">
        <template v-slot="{row}">
          {{getSuccessRate(row)}}
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="失败率">
        <template v-slot="{row}">
          {{getFailRate(row)}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="!showTop10"
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
  </div>
</template>

<script>
  export default {
    name: "ReportDetail",
    data() {
      return {
        time: ['', ''],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        tableData: [],
        currentPage: 1,
        pageSize: 10,
        totalElement: 0,
        showTop10: false,
        reportType: "",
        showStartTime: "",
        showEndTime: "",
      }
    },
    created() {
      this.reportType = this.$route.params.reportType;
      this.showStartTime = this.$route.params.showStartTime;
      this.showEndTime = this.$route.params.showEndTime;
      if (this.reportType != 'custom') {
        this.getStatistics();
      }
    },
    methods: {
      getSuccessRate(row) {
        let num = parseFloat(row.sTimes / row.tTimes).toFixed(4);
        return num * 100 + "%";
      },
      getFailRate(row) {
        let num = parseFloat(row.eTimes / row.tTimes).toFixed(4);
        return num * 100 + "%";
      },
      getUnusualTop() {
        this.showTop10 = true;
        let data = {
          type: this.reportType,
          startTime: this.reportType == 'custom' ? this.time[0] : this.showStartTime,
          endTime: this.reportType == 'custom' ? this.time[1] : this.showEndTime,
        };
        this.$axios.post(this.apiUrl + 'apimonitor/detectionerrortop', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.tableData = data.list;
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      getStatistics() {
        this.showTop10 = false;
        let data = {
          startTime: this.reportType == 'custom' ? this.time[0] : this.showStartTime,
          endTime: this.reportType == 'custom' ? this.time[1] : this.showEndTime,
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          type: this.reportType
        };
        this.$axios.post(this.apiUrl + 'apimonitor/detectionstatistic', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.tableData = data.list;
              this.totalElement = data.total;
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getStatistics()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getStatistics()
      }
    }
  }
</script>

<style scoped>

</style>
